import { render, staticRenderFns } from "./ImageSvg.vue?vue&type=template&id=1507af5b&lang=pug"
import script from "./ImageSvg.vue?vue&type=script&lang=ts"
export * from "./ImageSvg.vue?vue&type=script&lang=ts"
import style0 from "./ImageSvg.module.scss?vue&type=style&index=0&prod&module=true&lang=scss&external"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports